import { Box } from '@chakra-ui/react'
import styled from '@emotion/styled'
import { media } from 'components/utils/breakpoints'

export const Actions = styled(Box)``

export const Search = styled(Box)`
    input {
        position: relative;
        right: 0;
        transition: all 0.3s;
    }
    label {
        z-index: 0;
    }
    @media ${media('md', 'max')} {
        input:not(.show) {
            width: 0px;
            padding: 0;

            &::placeholder {
                visibility: hidden;
            }
        }
    }
`
